import { Component, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterModule } from '@angular/router';
import { Auth } from '../../../../core/services/auth.service';
import { OrderService } from '../../../../core/services/order.service';
import { Subscription, switchMap, timer } from 'rxjs';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.css'
})
export class AdminLayoutComponent implements OnInit, OnDestroy {
  constructor(private auth: Auth, private cd: ChangeDetectorRef, private orderService: OrderService) {}

  readonly newPaidPollMs = 60000;
  newPaidWebOrders = 0;
  private newPaidSub?: Subscription;

  isSidebarVisible: boolean = false;
  isProductsMenuOpen = false;
  isOrdersMenuOpen = false;
  isWebOrdersMenuOpen = false;
  isUsersMenuOpen = false;
  isSystemMenuOpen = false; // <--- Nuevo para Auditoría

  adminName: string = 'Admin';

  ngOnInit(): void {
    this.loadAdminInfo();
    this.newPaidSub = timer(0, this.newPaidPollMs)
      .pipe(switchMap(() => this.orderService.getNewPaidWebOrdersCount()))
      .subscribe({
        next: (res) => {
          this.newPaidWebOrders = res?.count || 0;
          this.cd.detectChanges();
        },
        error: (err) => console.error('Error contador ventas web', err)
      });
  }

  ngOnDestroy(): void {
    this.newPaidSub?.unsubscribe();
  }

  markNewPaidWebOrdersSeen() {
    if (this.newPaidWebOrders === 0) return;
    this.orderService.markNewPaidWebOrdersSeen().subscribe({
      next: () => {
        this.newPaidWebOrders = 0;
        this.cd.detectChanges();
      },
      error: (err) => console.error('Error marcando ventas web vistas', err)
    });
  }

  toggleSidebar() {
    this.isSidebarVisible = !this.isSidebarVisible;
  }

  toggleProductsMenu() {
    this.isProductsMenuOpen = !this.isProductsMenuOpen;
  }

  toggleOrdersMenu() {
    this.isOrdersMenuOpen = !this.isOrdersMenuOpen;
  }

  toggleWebOrdersMenu() {
    this.isWebOrdersMenuOpen = !this.isWebOrdersMenuOpen;
  }

  toggleUsersMenu() {
    this.isUsersMenuOpen = !this.isUsersMenuOpen;
  }

  toggleSystemMenu() { // <--- Nuevo
    this.isSystemMenuOpen = !this.isSystemMenuOpen;
  }

  loadAdminInfo() {
    this.auth.getUserInfoFromToken().subscribe({
      next: (user) => {
        this.adminName = user.fullName || user.fullname || user.username || 'Admin';
        this.cd.detectChanges();
      },
      error: (err) => console.error("Error en topbar", err)
    });
  }

  onLogout() {
    this.auth.logout().subscribe(() => {
      window.location.href = '/';
    });
  }
}
